export default function initVideoModal() {
  const modal = document.getElementById("js-video-modal");
  const video = document.getElementById("js-video-modal-video");
  const iframe = document.getElementById("js-video-modal-iframe");
  const closeBtn = document.getElementById("js-video-modal-close");
  const triggers = document.querySelectorAll(".js-video-modal-trigger");

  if (!modal || !video) return;

  triggers.forEach((trigger) => {
    trigger.addEventListener("click", (e) => {
      e.preventDefault();
      const src = trigger.getAttribute("href");
      if (src) {
        if (src.includes("youtube.com") || src.includes("youtu.be")) {
          // It's a YouTube link
          let embedUrl = src;
          if (src.includes("watch?v=")) {
            embedUrl = src.replace("watch?v=", "embed/") + "?autoplay=1";
          }
          video.style.display = "none";
          if (iframe) {
            iframe.style.display = "block";
            iframe.src = embedUrl;
          }
        } else {
          // It's a local video
          if (iframe) iframe.style.display = "none";
          video.style.display = "block";
          video.src = src;
          video.play().catch(() => {
            // Ignore play errors (e.g. user hasn't interacted with document)
          });
        }
        modal.showModal();
      }
    });
  });

  const close = () => {
    modal.close();
    video.pause();
    video.currentTime = 0;
    if (iframe) {
      iframe.src = "";
    }
  };

  if (closeBtn) {
    closeBtn.addEventListener("click", close);
  }

  modal.addEventListener("click", (e) => {
    if (e.target === modal) {
      close();
    }
  });
}
